import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 32, height: 32, rx: 16, fill: "#1A2023", fillOpacity: 0.05 }), /* @__PURE__ */ React.createElement("path", { d: "M21.5984 10.4004L10.3984 21.6004M21.5984 21.6004L10.3984 10.4004L21.5984 21.6004Z", stroke: "#A4A5AA", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
